import TopPage from "~/pages/top/TopPage.vue";
import InformationList from "~/pages/information/InformationList.vue";
import InformationDetail from "~/pages/information/InformationDetail.vue";
import TaikyoRoomSelect from "src/pages/taikyo/shinsei/TaikyoRoomSelect.vue";
import TaikyoFlowGuidePage from "src/pages/taikyo/shinsei/TaikyoFlowGuidePage.vue";
import TaikyoPrecautionsPage from "src/pages/taikyo/shinsei/TaikyoPrecautionsPage.vue";
import TaikyoEntryPage from "~/pages/taikyo/shinsei/TaikyoEntryPage.vue";
import TaikyoEntryCheckPage from "~/pages/taikyo/shinsei/TaikyoEntryCheckPage.vue";
import TaikyoCompletePage from "~/pages/taikyo/shinsei/TaikyoCompletePage.vue";
import TaikyoEntryCompletePage from "~/pages/taikyo/shinsei/TaikyoEntryCompletePage.vue";
import NyukyoInfoPage from "~/pages/nyukyoInfo/NyukyoInfoPage.vue";
import KeiyakuInfoPage from "~/pages/keiyaku/shokai/KeiyakuInfoPage.vue";
import MailAddressChangePage from "~/pages/keiyaku/mail/MailAddressChangePage.vue";
import MailAddressCheckPage from "~/pages/keiyaku/mail/MailAddressCheckPage.vue";
import MailAddressChangeCompletePage from "~/pages/keiyaku/mail/MailAddressChangeCompletePage.vue";
import PasswordChangePage from "~/pages/keiyaku/password/PasswordChangePage.vue";
import PasswordChangeCompletePage from "~/pages/keiyaku/password/PasswordChangeCompletePage.vue";
import SeikyuInfoPage from "~/pages/seikyuInfo/SeikyuInfoPage.vue";
import KaiyakuGuidePage from "~/pages/taikyo/kaiyaku/KaiyakuGuidePage.vue";
import KaiyakuSeisanPage from "~/pages/taikyo/seisan/KaiyakuSeisanPage.vue";
import KaiyakuEntryPage from "~/pages/taikyo/kaiyaku/KaiyakuEntryPage.vue";
import KaiyakuEntryHasonPage from "~/pages/taikyo/kaiyaku/KaiyakuEntryHasonPage.vue";
import KaiyakuEntryCheckPage from "~/pages/taikyo/kaiyaku/KaiyakuEntryCheckPage.vue";
import KaiyakuEntryCompletePage from "~/pages/taikyo/kaiyaku/KaiyakuEntryCompletePage.vue";
import ShomeiEntryCheckPage from "~/pages/shomei/ShomeiEntryCheckPage.vue";
import ShomeiListPage from "~/pages/shomei/ShomeiListPage.vue";
import ShomeiEntryPage from "~/pages/shomei/ShomeiEntryPage.vue";
import ShomeiEntryCompletePage from "~/pages/shomei/ShomeiEntryCompletePage.vue";
import ShomeiPrecautionsPage from "~/pages/shomei/ShomeiPrecautionsPage.vue";
import ShinjoshoEdit from "~/pages/keiyaku/shokai/ShinjoshoEditPage.vue";
import { next } from "./taikyoGuard";
import TermsOfUseComfirm from "~/pages/TermsOfUseComfirm/TermsOfUseComfirm.vue";
import ShomeiRoomSelect from "~/pages/shomei/ShomeiRoomSelect.vue";
/**入居者(個人)ユーザ用ルート */
const nyukyoshaRoutes = [
    { name: "", path: "", component: TopPage },
    { name: "top", path: "top", component: TopPage },
    { name: "nyukyo", path: "nyukyo", component: NyukyoInfoPage },
    { name: "keiyaku", path: "keiyaku", component: KeiyakuInfoPage },
    { name: "information-list", path: "information-list", component: InformationList },
    { name: "information-detail", path: "information-detail", component: InformationDetail },
    { name: "password-change", path: "password-change", component: PasswordChangePage },
    { name: "password-change-complete", path: "password-change-complete", component: PasswordChangeCompletePage },
    { name: "mailaddress-change", path: "mailaddress-change", component: MailAddressChangePage },
    { name: "mailaddress-check", path: "mailaddress-check", component: MailAddressCheckPage },
    { name: "mailaddress-change-complete", path: "mailaddress-change-complete", component: MailAddressChangeCompletePage },
    { name: "taikyo", path: "taikyo", component: TaikyoPrecautionsPage, beforeEnter: next },
    { name: "taikyo-room-list", path: "taikyo-room-list", component: TaikyoRoomSelect },
    { name: "taikyo-room-list-next", path: "taikyo-room", component: TaikyoRoomSelect, beforeEnter: next },
    { name: "taikyo-flow-guide", path: "taikyo-flow-guide", component: TaikyoFlowGuidePage },
    { name: "taikyo-flow-next", path: "taikyo-flow", component: TaikyoFlowGuidePage, beforeEnter: next },
    { name: "taikyo-precaution", path: "taikyo-precaution", component: TaikyoPrecautionsPage },
    { name: "taikyo-entry-complete", path: "taikyo-entry-complete", component: TaikyoEntryCompletePage },
    { name: "taikyo-complete", path: "taikyo-complete", component: TaikyoCompletePage },
    { name: "kaiyaku-guide", path: "kaiyaku-guide", component: KaiyakuGuidePage },
    { name: "taikyo-entry", path: "taikyo-entry", component: TaikyoEntryPage },
    { name: "taikyo-entry-check", path: "taikyo-entry-check", component: TaikyoEntryCheckPage },
    { name: "kaiyaku-entry", path: "kaiyaku-entry", component: KaiyakuEntryPage },
    { name: "kaiyaku-entry-hason", path: "kaiyaku-entry-hason", component: KaiyakuEntryHasonPage },
    { name: "kaiyaku-entry-check", path: "kaiyaku-entry-check", component: KaiyakuEntryCheckPage },
    { name: "kaiyaku-entry-complete", path: "kaiyaku-entry-complete", component: KaiyakuEntryCompletePage },
    { name: "seikyu", path: "seikyu", component: SeikyuInfoPage },
    { name: "shomei-room-list", path: "shomei-room-list", component: ShomeiRoomSelect },
    { name: "shomei-list", path: "shomei-list", component: ShomeiListPage },
    { name: "shomei-precautions", path: "shomei-precautions", component: ShomeiPrecautionsPage },
    { name: "shomei-shinsei-entry-check", path: "shomei-shinsei-check", component: ShomeiEntryCheckPage },
    { name: "shomei-entry-complete", path: "shomei-entry-complete", component: ShomeiEntryCompletePage },
    { name: "shomei-shinsei", path: "shomei-shinsei", component: ShomeiEntryPage },
    { name: "kaiyaku-seisan", path: "kaiyaku-seisan", component: KaiyakuSeisanPage },
    { name: "shinjosho-edit", path: "shinjosho-edit", component: ShinjoshoEdit },
    { name: "terms-of-use-confirm", path: "terms-of-use-confirm", component: TermsOfUseComfirm },
    { name: "nyukyosha-list", path: "", component: TopPage }
];
export default nyukyoshaRoutes;
